export default __webpack_public_path__ + "static/media/mouse.aa1ae374.png";